import {PropertyResponse} from '@mintdata-wsp/common/controllers/network/extended/responses/PropertyResponse';
import {VisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponent';
import {FlowBlock} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {CloudComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import _get from 'lodash/get';

export class NameUtil
{
    private static _removeComponentSuffix(name:string):string
    {
        const lcName = name.toLowerCase();

        if( lcName.endsWith('component') )
            name = name.substring(0, name.length - 'component'.length);
        else if( lcName.endsWith('component<t>') )
            name = name.substring(0, name.length - 'component<t>'.length);

        return name.trim();
    }

    public static getPropertyDisplayName(prop:PropertyResponse):string
    {
        return _get(prop, 'label', NameUtil._computeName(prop.name));
    }

    public static getDisplayName(component:CloudComponent | VisualComponent):string
    {
        return NameUtil._computeName(component.name);
    }

    public static getDashedName(name:string):string
    {
        let dashedName = name.trim().charAt(0).toLowerCase() + name.substring(1);

        return dashedName
            .replace(/ /g, '')
            .replace(/([A-Z])/g, (char:string) => '-' + char.toLowerCase());
    }

    public static getInstanceOrBlockName(flowBlock:FlowBlock):string
    {
        if( flowBlock.instanceName )
            return flowBlock.instanceName;
        else
            return NameUtil.getDisplayName(flowBlock.component);
    }

    private static _computeName(name:string):string
    {
        let sb = '';

        if( name.indexOf(' ') !== -1 )
        {
            const parts = name.split(' ');

            for( let part of parts )
            {
                if( part.length > 1 )
                    sb += part.charAt(0).toUpperCase() + part.substring(1).toLowerCase();
                else
                    sb += part.charAt(0).toUpperCase();

                sb += ' ';
            }

            sb = sb.trim();
            return NameUtil._removeComponentSuffix(sb);
        }
        else
        {
            sb = name.replace(/([A-Z](?=[a-z])|(?:![A-Z])[A-Z])/g, ' $1'); // insert a space before all caps
            return NameUtil._removeComponentSuffix(sb);
        }
    }
}
